import DOMPurify from "dompurify";

// Sanitizes trusted-admin HTML (incl. KaTeX output) before injecting into the DOM.
// Prevents stored XSS while preserving math markup (MathML/SVG) and safe formatting.
export function sanitizeHtml(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    ADD_ATTR: ["target", "rel"],
    ADD_TAGS: ["math", "semantics", "annotation", "mrow", "mi", "mo", "mn", "msup", "msub", "mfrac", "msqrt", "mroot", "mtext", "munderover", "munder", "mover", "mspace", "mtable", "mtr", "mtd"],
  });
}
